import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

function AboutPage() {
  return (
    <div className="about-page page">
      <Helmet>
        <title>About TaxClip — UK Tax Calculator</title>
        <meta name="description" content="Learn about TaxClip, our mission to make UK tax simple, and how to get in touch." />
        <link rel="canonical" href="https://taxclip.co.uk/about" />
        <meta property="og:title" content="About TaxClip — UK Tax Calculator" />
        <meta property="og:description" content="Learn about TaxClip, our mission to make UK tax simple, and how to get in touch." />
        <meta property="og:url" content="https://taxclip.co.uk/about" />
      </Helmet>
      <h1 className="about-title">About TaxClip</h1>
      <p className="about-lead">
        We want to make tax calculations simple and accessible for everyone in the UK.
        No jargon, no sign-up required — just clear, instant answers.
      </p>
      <div className="about-cards">
        <div className="about-card">
          <div className="about-card-title">Our Mission</div>
          <div className="about-card-text">
            To provide an easy-to-use platform for UK tax calculations and help people find the right financial expert.
          </div>
        </div>
        <div className="about-card">
          <div className="about-card-title">Terms of Service</div>
          <div className="about-card-text">
            Please find our terms of service and privacy policy <Link to="/terms-of-service">here</Link>.
          </div>
        </div>
        <div className="about-card">
          <div className="about-card-title">Contact Us</div>
          <div className="about-card-text">
            Feel free to reach out at <a href="mailto:support@taxclip.co.uk">support@taxclip.co.uk</a>.
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;
